<div class="settings-container" *ngIf="!isLoading">
    <div class="groups-counter">
        {{ 'alarm-groups-settings.counter' | translate: { num: alarmGroups.length } }}
        <div class="info-icon-container">
            <mat-icon
                svgIcon="help"
                class="help-icon"
                (click)="$event.stopImmediatePropagation(); isShowingInfo = !isShowingInfo" />
            <ng-container *ngIf="isShowingInfo">
                <div class="info-message-container" #infoMessage>
                    {{ 'alarm-groups-settings.counter.info-1' | translate }}
                    <span class="bold">
                        {{ 'channel-sheet.tab.alarm-group' | translate }}
                    </span>
                    {{ 'alarm-groups-settings.counter.info-2' | translate }}
                    <span class="bold">
                        {{ 'alarm-groups-settings.counter.info-3' | translate }}
                    </span>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="groups-container">
        <div class="group-table-row header">
            <div class="group-no column">
                {{ 'alarm-groups-settings.table-header.number' | translate }}
            </div>
            <div class="name column">
                {{ 'alarm-groups-settings.table-header.alarm' | translate }}
            </div>
            <div class="inputs-counter column">
                {{ 'alarm-groups-settings.table-header.total' | translate }}
            </div>
            <div class="col-options column"></div>
        </div>
        <ng-container *ngIf="!alarmGroups || alarmGroups?.length == 0">
            <div class="empty-groups-container">
                <mat-icon svgIcon="empty-box" class="empty-box-icon" />
                <div class="empty-groups-text">
                    {{ 'alarm-groups-settings.empty.1' | translate }}
                    <br />
                    {{ 'alarm-groups-settings.empty.2' | translate }}
                    <span class="channel-route-button" (click)="openAlarmsGroupPage()">
                        {{ 'alarm-groups-settings.empty.3' | translate }}
                    </span>
                    {{ 'alarm-groups-settings.empty.4' | translate }}
                </div>
            </div>
        </ng-container>
        <div *ngFor="let group of alarmGroups" class="group-table-row">
            <div class="group-no column group-num">
                {{ group.groupNo }}
            </div>
            <div
                class="name column"
                data-cy="ops-settings-console-settings-alarm-grp-name"
                [class.noName]="!group.name">
                {{ group.name ? group.name : ('alarm-group.page.no-name-message' | translate) }}
            </div>
            <div class="inputs-counter column">
                {{ group.outputSettings ? getSettingsString(group) : '-' }}
            </div>
            <div
                class="col-options column edit-button"
                data-cy="ops-settings-console-settings-alarm-grp-edit-address-button"
                (click)="openSettings(group)">
                {{
                    group.groupSettings
                        ? ('alarm-groups-settings.dialog.edit' | translate)
                        : ('alarm-groups-settings.dialog.save' | translate)
                }}
            </div>
        </div>
    </div>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
